import { create } from 'zustand';
import { ApiUtils, RequestStrategyEnum } from '@shared/utils';
import { ProfileApi, type ChangePasswordRequest } from '@shared/api';

interface ChangePasswordType {
  loading: boolean;
  error: string | null;
  success: boolean;
  change: (request: ChangePasswordRequest, signal?: AbortSignal) => Promise<void>;
  clear: () => void;
}

export const useChangePasswordStore = create<ChangePasswordType>((set) => ({
  loading: false,
  error: null,
  success: false,

  change: ApiUtils.wrapperApi(async (request, signal) => {
    try {
      set({ loading: true, error: null, success: false });
      await ProfileApi.changePassword(request, signal);
      set({ success: true, loading: false });
    } catch (error) {
      set({ error: ApiUtils.getApiError(error), loading: false });
    }
  }, RequestStrategyEnum.Debounce),

  clear: () => set({ loading: false, success: false, error: null }),
}));
